/* Certification Api Module */
import { requester } from '@/libs/requester';
import { AT } from '@/libs/translation';
import type {
  CreateEmailCertificationCheckEmailControllerReqBodyType,
  CreateEmailCertificationResetPwControllerReqBodyType,
  CreateMobileCertificationControllerReqBodyType,
  FindEmailControllerReqBodyType,
  FindEmailControllerResBodyType,
  ResetPwControllerReqBodyType,
  VerifyEmailCertificationControllerReqBodyType,
  VerifyMobileCertificationControllerReqBodyType,
} from '../type';

export const postMobileCertification = (form: CreateMobileCertificationControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/auth/mobile-certification`, form);
};

export const postVerifyMobileCertification = (form: VerifyMobileCertificationControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/auth/mobile-certification/verify`, form);
};

export const postEmailCertificationResetPw = (form: CreateEmailCertificationResetPwControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/auth/email-certification/reset-password`, form);
};

export const postEmailCertificationCheckEmail = (form: CreateEmailCertificationCheckEmailControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/auth/email-certification/check-email`, form);
};

export const postVerifyEmailCertification = (form: VerifyEmailCertificationControllerReqBodyType) => {
  return requester.post(`/${AT.language}/api/v1/auth/email-certification/verify`, form);
};

export const postFindEmail = (form: FindEmailControllerReqBodyType) => {
  return requester.post<FindEmailControllerResBodyType>(`/${AT.language}/api/v1/auth/find-email`, form);
};

export const postResetPw = (form: ResetPwControllerReqBodyType) => {
  return requester.post<ResetPwControllerReqBodyType>(`/${AT.language}/api/v1/auth/reset-password`, form);
};
